import { useField } from "formik";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import SelectNodeType from "../../types/SelectNodeType";
import normalizeOptions from "./normalizeOptions";

const SelectNode = ({ name, label, options = [], multiple, required, size, ...props }: SelectNodeType) => {
  const [field, meta, helpers] = useField(name);
  const items = normalizeOptions(options);

  return (
      <FormControl
          fullWidth
          required={required}
          error={meta.touched && Boolean(meta.error)}
      >
        <InputLabel size={size || 'small'}>{label}</InputLabel>
        <Select
            size={size || 'small'}
            label={label}
            multiple={multiple ?? false}
            value={field.value ?? (multiple ? [] : "")}
            onChange={(e) => helpers.setValue(e.target.value)}
            onBlur={() => helpers.setTouched(true)}
            {...props}
        >
          {items.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label ?? opt.value}
              </MenuItem>
          ))}
        </Select>
        {meta.touched && meta.error && (
            <FormHelperText>{meta.error}</FormHelperText>
        )}
      </FormControl>
  );
};

export default SelectNode;
